import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import CampaignService from "../../../_services/CampaignService";

interface Props {
  show: boolean;
  onHide: () => void;
  onSelect: (starter: any) => void;
  /** Modal heading. Defaults to the email wording. */
  title?: string;
  /**
   * Loads the starter list. Defaults to the email starters endpoint; the
   * document-templates page passes its own loader so the same premium picker
   * serves invoice/receipt standards too.
   */
  loadStarters?: () => Promise<any[]>;
}

const StarterTemplatePickerModal: React.FC<Props> = ({
  show,
  onHide,
  onSelect,
  title = "Choose a Starter Template",
  loadStarters,
}) => {
  const [starters, setStarters] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (show) {
      setLoading(true);
      setError(null);
      setStarters([]);
      const loader =
        loadStarters ||
        (() => CampaignService.getStarterTemplates().then((res) => res.data?.data || []));
      loader()
        .then((list) => setStarters(list || []))
        .catch((err) => {
          const status = err?.response?.status;
          if (status === 401 || status === 403) {
            setError("Your session has expired. Please log in again to load starter templates.");
          } else {
            setError(
              err?.response?.data?.message ||
                err?.message ||
                "Failed to load starter templates",
            );
          }
        })
        .finally(() => setLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ minHeight: 240 }}>
        {loading ? (
          <div style={{ textAlign: "center", padding: 30 }}>Loading starters...</div>
        ) : error ? (
          <div
            style={{
              padding: 16,
              borderRadius: 6,
              background: "#fdecea",
              color: "#b71c1c",
              fontSize: 14,
            }}
          >
            {error}
          </div>
        ) : starters.length === 0 ? (
          <div style={{ textAlign: "center", padding: 30, color: "var(--text-faint)" }}>
            No starter templates available.
          </div>
        ) : (
          <div className="starter-grid">
            {starters.map((s: any) => (
              <div
                key={s.id}
                className="starter-card"
                onClick={() => onSelect(s)}
              >
                <div className="starter-card-preview">
                  <div
                    className="starter-card-preview-inner"
                    dangerouslySetInnerHTML={{ __html: s.html }}
                  />
                </div>
                <div className="starter-card-info">
                  <h6>{s.name}</h6>
                  <small>{s.category}</small>
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default StarterTemplatePickerModal;
